import { ActionReducerMap } from '@ngrx/store';
import { SciGuaduaKey, SciGuaduaReducer, SciGuaduaState } from '@scifamek/guadua';
import { apartmentReducer } from './features/apartment/state-management/apartment.reducer';
import { ApartmentState } from './features/apartment/state-management/apartment.state';
import { bookingKey, BookingReducer } from './features/booking/state-management/booking.reducer';
import { BookingState } from './features/booking/state-management/booking.state';
import {
  buildingKey,
  BuildingReducer,
} from './features/building/state-management/building.reducer';
import { BuildingState } from './features/building/state-management/building.state';
import {
  categoryKey,
  CategoryReducer,
} from './features/category/state-management/category.reducer';
import { CategoryState } from './features/category/state-management/category.state';
import { doormanKey, DoormanReducer } from './features/doorman/state-management/doorman.reducer';
import { DoormanState } from './features/doorman/state-management/doorman.state';
import { packageKey, PackageReducer } from './features/package/state-management/package.reducer';
import { PackageState } from './features/package/state-management/package.state';
import {
  packagePurchaseKey,
  PackagePurchaseReducer,
} from './features/package-purchase/state-management/package-purchase.reducer';
import { PackagePurchaseState } from './features/package-purchase/state-management/package-purchase.state';
import {
  permanenceBuildingKey,
  PermanenceBuildingReducer,
} from './features/permanence-building/state-management/permanence-building.reducer';
import { PermanenceBuildingState } from './features/permanence-building/state-management/permanence-building.state';
import {
  residentKey,
  ResidentReducer,
} from './features/resident/state-management/resident.reducer';
import { ResidentState } from './features/resident/state-management/resident.state';
import {
  subcategoryKey,
  SubcategoryReducer,
} from './features/subcategory/state-management/subcategory.reducer';
import { SubcategoryState } from './features/subcategory/state-management/subcategory.state';
import { vendorKey, VendorReducer } from './features/vendor/state-management/vendor.reducer';
import { VendorState } from './features/vendor/state-management/vendor.state';
import {
  vendorPaymentKey,
  VendorPaymentReducer,
} from './features/vendor-payment/state-management/vendor-payment.reducer';
import { VendorPaymentState } from './features/vendor-payment/state-management/vendor-payment.state';
import {
  vendorRateKey,
  VendorRateReducer,
} from './features/vendor-rate/state-management/vendor-rate.reducer';
import { VendorRateState } from './features/vendor-rate/state-management/vendor-rate.state';
import { authKey, authReducer } from './features/auth/state-management/auth.reducer';
import { AuthState } from './features/auth/state-management/auth.state';
import { membershipReducer } from './features/membership/state-management/membership.reducer';
import { MembershipState } from './features/membership/state-management/membership.selectors';
import { baseKey, BaseReducer } from './state-management/base.reducer';
import { BaseState } from './state-management/base.state';
import {
  vendorCompanyKey,
  VendorCompanyReducer,
} from './features/vendor-company/state-management/vendor-company.reducer';
import { VendorCompanyState } from './features/vendor-company/state-management/vendor-company.state';
import { BuildingAreaState } from './features/building-area/state-management/building-area.state';
import {
  buildingAreaKey,
  BuildingAreaReducer,
} from './features/building-area/state-management/building-area.reducer';
import {
  accessPassKey,
  accessPassReducer,
} from './features/access-pass/state-management/access-pass.reducer';
import { AccessPassState } from './features/access-pass/state-management/access-pass.state';
import {
  bookingPassKey,
  bookingPassReducer,
} from './features/booking-pass/state-management/booking-pass.reducer';
import { BookingPassState } from './features/booking-pass/state-management/booking-pass.state';
import { agencyKey, agencyReducer } from './features/agency/state-management/agency.reducer';
import { AgencyState } from './features/agency/state-management/agency.state';
import { AgencyAdminState } from './features/agency-admin/state-management/agency-admin.state';
import {
  agencyAdminKey,
  agencyAdminReducer,
} from './features/agency-admin/state-management/agency-admin.reducer';
import {
  agencyUserKey,
  agencyUserReducer,
} from './features/agency-user/state-management/agency-user.reducer';
import { AgencyUserState } from './features/agency-user/state-management/agency-user.state';
import {
  agencyApartmentAssignmentKey,
  agencyApartmentAssignmentReducer,
} from './features/agency-apartment-assignment/state-management/agency-apartment-assignment.reducer';
import { AgencyApartmentAssignmentState } from './features/agency-apartment-assignment/state-management/agency-apartment-assignment.state';
import { DynamicPermissionState } from './features/dynamic-permission/state-management/dynamic-permission.state';
import {
  dynamicPermissionKey,
  DynamicPermissionReducer,
} from './features/dynamic-permission/state-management/dynamic-permission.reducer';

export default interface AppState {
  [accessPassKey]: AccessPassState;
  [agencyKey]: AgencyState;
  [agencyAdminKey]: AgencyAdminState;
  [agencyApartmentAssignmentKey]: AgencyApartmentAssignmentState;
  [agencyUserKey]: AgencyUserState;
  [baseKey]: BaseState;
  [SciGuaduaKey]: SciGuaduaState;
  [authKey]: AuthState;
  apartment: ApartmentState;
  [bookingKey]: BookingState;
  [bookingPassKey]: BookingPassState;
  [buildingKey]: BuildingState;
  [buildingAreaKey]: BuildingAreaState;
  [categoryKey]: CategoryState;
  [doormanKey]: DoormanState;
  [dynamicPermissionKey]: DynamicPermissionState;
  [packageKey]: PackageState;
  [packagePurchaseKey]: PackagePurchaseState;
  [permanenceBuildingKey]: PermanenceBuildingState;
  [residentKey]: ResidentState;
  [subcategoryKey]: SubcategoryState;
  [vendorKey]: VendorState;
  [vendorPaymentKey]: VendorPaymentState;
  [vendorRateKey]: VendorRateState;
  [vendorCompanyKey]: VendorCompanyState;
  membership: MembershipState;
}

export const ROOT_REDUCERS: ActionReducerMap<AppState> = {
  base: BaseReducer,
  agency: agencyReducer,
  'agency-admin': agencyAdminReducer,
  'agency-user': agencyUserReducer,
  'agency-apartment-assignment': agencyApartmentAssignmentReducer,
  SciGuadua: SciGuaduaReducer,
  accessPass: accessPassReducer,
  auth: authReducer,
  apartment: apartmentReducer,
  booking: BookingReducer,
  bookingPass: bookingPassReducer,
  building: BuildingReducer,
  buildingArea: BuildingAreaReducer,
  category: CategoryReducer,
  doorman: DoormanReducer,
  dynamicPermission: DynamicPermissionReducer,
  membership: membershipReducer,
  package: PackageReducer,
  packagePurchase: PackagePurchaseReducer,
  permanenceBuilding: PermanenceBuildingReducer,
  resident: ResidentReducer,
  subcategory: SubcategoryReducer,
  vendor: VendorReducer,
  vendorPayment: VendorPaymentReducer,
  vendorRate: VendorRateReducer,
  vendorCompany: VendorCompanyReducer,
};
